import Api from 'api';
import {
  GET_COST_CENTERS,
  SET_COST_CENTERS_PAGINATION,
  SET_COST_CENTERS_FILTERS,
  RESET_COST_CENTERS,
  TOGGLE_COST_CENTER,
  ADD_COST_CENTER,
  UPDATE_COST_CENTER,
  GET_COST_CENTER_BY_ID,
  RESET_COST_CENTER_FORM,
  MODIFY_CUSTOM_FIELD_EDITING_COST_CENTER, //Groups
  MODIFY_EDITING_COST_CENTER,
} from 'cost_centers/constants';

export const setPagination = (payload) => ({
  type: SET_COST_CENTERS_PAGINATION,
  payload,
});

export const setFilters = (payload) => ({
  type: SET_COST_CENTERS_FILTERS,
  payload,
});

export const getCostCenters = (companyId, subcompanyId, filters, limit, page, orderBy, order) => ({
  type: GET_COST_CENTERS,
  meta: { needAuth: true },
  payload: Api.costCenters.get(companyId, subcompanyId, filters, limit, page, orderBy, order),
});

export const reset = () => ({ type: RESET_COST_CENTERS });

export const toggle = (costCenterId, companyId, subcompanyId) => ({
  type: TOGGLE_COST_CENTER,
  meta: { id: costCenterId, needAuth: true },
  payload: Api.costCenters.toggle(costCenterId, companyId, subcompanyId),
});

export const resetForm = () => ({ type: RESET_COST_CENTER_FORM });

export const getCostCenterById = (costCenterId, companyId, subcompanyId) => ({
  type: GET_COST_CENTER_BY_ID,
  meta: { needAuth: true },
  payload: Api.costCenters.getById(costCenterId, companyId, subcompanyId),
});

export const modifyCostCenter = (payload) => ({ type: MODIFY_EDITING_COST_CENTER, payload });

//Groups
export const modifyCustomField = (payload) => ({
  type: MODIFY_CUSTOM_FIELD_EDITING_COST_CENTER,
  payload,
}); // Agregado

export const addCostCenter = (companyId, subcompanyId, costCenter) => ({
  type: ADD_COST_CENTER,
  payload: Api.costCenters.add(companyId, subcompanyId, costCenter),
});

export const updateCostCenter = (costCenterId, companyId, subcompanyId, costCenter) => ({
  type: UPDATE_COST_CENTER,
  meta: { id: costCenterId, needAuth: true },
  payload: Api.costCenters.update(costCenterId, companyId, subcompanyId, costCenter),
});



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/actions/cost_centers_actions.js